import { useMutation, useQueryClient } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import { QUERY_KEYS } from "../query/querykeys";

type BulkDeleteProjectsResponseType = ResponseType<{ deletedCount: number }>;

function useBulkDeleteProjectsMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation<
    AxiosResponseAndError<BulkDeleteProjectsResponseType>["response"],
    AxiosResponseAndError<BulkDeleteProjectsResponseType>["error"],
    { projectIds: string[] }
  >({
    mutationFn: (data) =>
      ApiRequest.post<BulkDeleteProjectsResponseType>(
        `${requestURLs.project}/bulk-delete`,
        data
      ),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.getProjects],
        }),
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.getProjectsNocal],
        }),
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.portfolioDashboard],
        }),
      ]);
    },
  });

  return mutation;
}

export default useBulkDeleteProjectsMutation;
